import { render, staticRenderFns } from "./clipboard.vue?vue&type=template&id=106be26e&"
import script from "./clipboard.vue?vue&type=script&lang=js&"
export * from "./clipboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports